export const getSolidOrGradientLinearBGColor = (colors: string[]) => {
  if (colors.length === 1) {
    return `${colors[0]!}`;
  }

  const interval = 100 / (colors.length - 1);

  return `linear-gradient(85deg, ${colors
    .map((color, index) => `${color} ${index * interval}%`)
    .join(',')})`;
};
